import { isString } from 'lodash';

function getValidString(str: string | null | undefined) {
  return isString(str) ? str.trim() : '';
}

function truncate(
  str: string,
  characters: number | null | undefined,
  preserveWords: boolean = false,
): string {
  const strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    const length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function camelCasify(text: string): string {
  return text
    .split(' ')
    .map((word, i) => {
      if (i > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }

      return word.toLowerCase();
    })
    .join('');
}

const upperCaseLetterToInt = (letter: string) => letter.charCodeAt(0) - 64;

function snakeToCamel(s: string) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

const camelToSnakeCase = (str: string | null | undefined): string =>
  str ? str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`) : '';

export {
  camelToSnakeCase,
  getValidString,
  truncate,
  camelCasify,
  upperCaseLetterToInt,
  snakeToCamel,
};
